// use timestamp + random numbers to generate a unique random string.
export const randomUniqueId = () => `${ Date.now() }.${ String(Math.floor(Math.random() * 1000000)).padStart(6, '0') }`;